import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { SplitText, useReveal } from 'components';

import { usePage } from '../../pages';
import BeforeAfter from './BeforeAfter';

import style from './Problems.module.scss';

const ProblemSection = ({ index, count, item, labels, children }) => {
  const ref = useRef(null);
  // Every other section puts the slider on the left
  const flip = index % 2 === 1;

  useReveal(ref);

  const copy = (
    <div
      className={style.copy}
      data-reveal
    >
      <p className={style.idx}>
        <b>{String(index + 1).padStart(2, '0')}</b> / {String(count).padStart(2, '0')} · {item.label}
      </p>
      <h3>{item.title}</h3>
      <p className={style.problem}>{item.problem}</p>
      <p className={style.solution}>
        <b>{labels.with}</b>
        <span>{item.solution}</span>
      </p>
    </div>
  );
  const slider = (
    <BeforeAfter
      index={index}
      item={item}
      labels={labels}
    />
  );

  return (
    <section
      id={index === 0 ? 'problemy' : `problem-${index + 1}`}
      ref={ref}
      className={cn('sec tone-light', style.section, index === 0 && style.first, index === count - 1 && style.last)}
      data-tone='light'
    >
      {children}
      <div className={cn('wrap', style.grid, flip && style.flip)}>
        {flip ? slider : copy}
        {flip ? copy : slider}
      </div>
    </section>
  );
};

const Problems = () => {
  const { t } = useTranslation('page');
  const { id } = usePage();
  const labels = t(`${id}.problems`, { returnObjects: true });

  return labels.items.map((item, i) => (
    <ProblemSection
      key={i}
      index={i}
      count={labels.items.length}
      item={item}
      labels={labels}
    >
      {i === 0 && (
        <div className={cn('wrap', style.intro)}>
          <SplitText
            as='h2'
            className='h2'
            reveal
          >
            {labels.title} <span className='serif-i accent-m'>{labels.titleAccent}</span>
          </SplitText>
          <p
            className='lead'
            data-reveal
          >
            {labels.lead}
          </p>
        </div>
      )}
    </ProblemSection>
  ));
};

export default Problems;
